const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR';
const HIDE_PROFILE_LOADER = 'HIDE_PROFILE_LOADER';
const SHOW_PROFILE_LOADER = 'SHOW_PROFILE_LOADER';
const UPDATE_IMAGE_REQUEST = 'UPDATE_IMAGE_REQUEST';
const UPDATE_IMAGE_SUCCESS = 'UPDATE_IMAGE_SUCCESS';
const UPDATE_IMAGE_ERROR = 'UPDATE_IMAGE_ERROR';
const DELETE_IMAGE_REQUEST = 'DELETE_IMAGE_REQUEST';
const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR';
const RESET_IMAGE_REQUEST = 'RESET_IMAGE_REQUEST';
const RESET_IMAGE_SUCCESS = 'RESET_IMAGE_SUCCESS';
const FETCH_PROFILE_JSON_REQUEST = 'FETCH_PROFILE_JSON_REQUEST';
const FETCH_PROFILE_JSON_SUCCESS = 'FETCH_PROFILE_JSON_SUCCESS';
const FETCH_PROFILE_JSON_ERROR = 'FETCH_PROFILE_JSON_ERROR';

const CREATE_STATIC_QR_REQUEST = 'CREATE_STATIC_QR_REQUEST';
const CREATE_STATIC_QR_SUCCESS = 'CREATE_STATIC_QR_SUCCESS';
const CREATE_STATIC_QR_ERROR = 'CREATE_STATIC_QR_ERROR';
const RESET_STATIC_QR_DATA = 'RESET_STATIC_QR_DATA';

export {
    CREATE_STATIC_QR_REQUEST,
    CREATE_STATIC_QR_SUCCESS,
    CREATE_STATIC_QR_ERROR,
    RESET_STATIC_QR_DATA,
    FETCH_PROFILE_REQUEST,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_ERROR,
    HIDE_PROFILE_LOADER,
    SHOW_PROFILE_LOADER,
    UPDATE_IMAGE_REQUEST,
    UPDATE_IMAGE_SUCCESS,
    UPDATE_IMAGE_ERROR,
    DELETE_IMAGE_REQUEST,
    DELETE_IMAGE_SUCCESS,
    DELETE_IMAGE_ERROR,
    RESET_IMAGE_REQUEST,
    RESET_IMAGE_SUCCESS,
    FETCH_PROFILE_JSON_REQUEST,
    FETCH_PROFILE_JSON_SUCCESS,
    FETCH_PROFILE_JSON_ERROR,
};
